import { Button, Typography } from '@mui/material';
import lodash from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DisplayFieldsFragment, DisplayType } from '../../../../../../../../../../../generated/core-api/graphql-react-query';
import DisplayDetailsDialog from './DisplayDetailsDialog';
import StyledBox from './styles';

interface DisplayOriginProps {
  displays: DisplayFieldsFragment[];
  total: number;
}

export default function DisplayOrigin(props: DisplayOriginProps) {
  const { displays, total } = props;
  const { t } = useTranslation('session');
  const [open, setOpen] = React.useState(false);

  const displaysFiltered = displays.filter((display) => display.displayType === DisplayType.Detection && !!display.detection)
    .map((display) => ({
      commandName: display.detection?.command?.name,
      card: display.card.title,
    }));
  const uniqCommands = lodash.uniqBy(displaysFiltered, 'commandName');
  if (!uniqCommands.length) {
    return (
      <StyledBox>
        <Typography>
          {t('list.displays', { count: total })}
        </Typography>
      </StyledBox>
    );
  } return (
    <StyledBox>
      <Typography>
        {t('list.displays', { count: total })}
      </Typography>
      {uniqCommands.length === 1 ? (
        <Typography variant="body2">
          {`(${uniqCommands[0].commandName})`}
        </Typography>
      ) : (
        <>
          <Button variant="text" color="primary" onClick={() => setOpen(true)}>
            {t('details.display.commands.count', { count: uniqCommands.length })}
          </Button>
          {open && (
            <DisplayDetailsDialog open={open} onClose={() => setOpen(false)} commands={uniqCommands} />)}
        </>
      )}
    </StyledBox>
  );
}
